<template>
  <main class="main">
    <header class="page-header">
      <h1>
        Posts
        <a href="#" title="RSS" aria-label="RSS">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round" height="23">
            <path d="M4 11a9 9 0 0 1 9 9" />
            <path d="M4 4a16 16 0 0 1 16 16" />
            <circle cx="5" cy="19" r="1" />
          </svg>
        </a>
      </h1>
      <div class="post-meta">
        <span>Unprofessional tech writings and reviews from experiences, codes, and tons of Google searches</span>
      </div>
    </header>
    <div class="archive-year" v-if="loaded">
      <div class="archive-month">
        <div class="archive-posts">
          <Post v-for="article in articles" :data="article" v-bind:key="article.id" />
        </div>
      </div>
    </div>
    <div class="post-content" v-else>
      <h3 id="intro">Loading stuff</h3>
      <p>Please wait</p>
      <hr>
    </div>
    <footer class="page-footer" v-if="loaded">
      <span class="centering-cta">
        <a class="cta-link" href="https://davidlares.medium.com" target="_blank" rel="noopener noreferrer">View complete Blog Profile »</a>
      </span>
    </footer>
  </main>
</template>

<script>
import Post from '@/components/Post'
import axios from "axios"
export default {
  name: 'Writings',
  data() {
    return {
      articles: {},
      loaded: false
    }
  },
  components: {
    Post
  },
  async mounted() {
    await this.loadArticles()
  },
  methods: {
    async loadArticles() {
      try {
        let articles = await axios.get(process.env.VUE_APP_MEDIUM_ENDPOINT)
        this.articles = articles.data.items
        this.articles.splice(5)
        this.loaded = true
      } catch (err) {
        console.log('err', err)
      }
    }
  }
}
</script>
